import { $ } from "js/vendor";
import React, { Component } from "reactn";
import { Fragment } from "react";
import { Button, MuiThemeProvider } from "@material-ui/core";
import { getStaticUrl } from "js/config";
import Icon from "js/react/components/Icon";
import theme from "js/react/materialThemeOverrides";
import { ds } from "js/core/models/dataService";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";

const ANIMATE_DURATION = 333;

export const UIContainerContext = React.createContext(true);

export class UIContainer extends Component {
    state = {
        shouldRender: true,
        isOpening: true
    };

    constructor() {
        super();
        this.containerRef = React.createRef();
    }

    componentDidMount() {
        ds.selection.element = null;
        this.animateOpen();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.isOpen && !this.props.isOpen) {
            this.props.onBeforeClose && this.props.onBeforeClose();
            this.animateClose();
        }
    }

    animateOpen() {
        let startWidth, endWidth;

        if ($(".editor_menu_bar").length > 0) {
            startWidth = 70;
        } else {
            startWidth = 0;
        }
        if (this.props.direction == "vertical") {
            endWidth = "100%";
        } else {
            endWidth = 200;
        }

        let $container = $(this.containerRef.current);
        $container.find(".ui-pane").velocity("transition.slideLeftBigIn", {
            duration: ANIMATE_DURATION + 100
        });

        $container.find(".ui-navigation").velocity(
            {
                width: [endWidth, startWidth],
                minWidth: endWidth,
                opacity: 1
            },
            {
                duration: ANIMATE_DURATION,
                complete: () => {
                    this.setState({ isOpening: false });
                }
            }
        );
    }

    animateClose() {
        let endWidth;
        if ($(".editor_menu_bar").length > 0) {
            endWidth = 70;
        } else {
            endWidth = 0;
        }

        let $container = $(this.containerRef.current);
        $container.find(".ui-pane").velocity("transition.slideLeftBigOut", {
            duration: ANIMATE_DURATION + 100
        });

        $container.find(".ui-navigation").velocity(
            {
                width: endWidth
            },
            {
                duration: ANIMATE_DURATION
            }
        );

        $container.find(".ui-navigation-items").velocity("transition.fadeOut", { duration: ANIMATE_DURATION });

        setTimeout(() => {
            this.setState({ shouldRender: false });
            // let the parent know we've finished closing
            this.props.onClose();
        }, ANIMATE_DURATION);
    }

    render() {
        const { onClick } = this.props;

        if (this.state.shouldRender) {
            return (
                <MuiThemeProvider theme={theme}>
                    <UIContainerContext.Provider value={this.state.isOpening}>
                        <div ref={this.containerRef}
                            className={`beautiful-ui ui-container ${this.props.direction} ${this.props.className}`}
                            onClick={event => onClick && onClick(event)}
                        >
                            {this.props.children}
                        </div>
                    </UIContainerContext.Provider>
                </MuiThemeProvider>
            );
        } else {
            return null;
        }
    }
}

export class UIPane extends Component {
    render() {
        return (
            <div {...this.props} className={`ui-pane ${this.props.className || ""}`}>
                {this.props.children}
            </div>
        );
    }
}

export class UIPaneWithSideBar extends Component {
    render() {
        return (
            <div {...this.props} className={`ui-pane with-sidebar ${this.props.className || ""}`}>
                {this.props.children}
            </div>
        );
    }
}

export class UIPaneHeader extends Component {
    render() {
        return <div className="ui-pane-header">{this.props.children}</div>;
    }
}

export class UIPaneSideBar extends Component {
    render() {
        return <div className="ui-pane-sidebar" style={this.props.style}>{this.props.children}</div>;
    }
}

export class UIPaneContents extends Component {
    render() {
        return (
            <div className="ui-inner-pane" onScroll={this.props.onScroll} style={this.props.style}>
                {this.props.children}
            </div>
        );
    }
}

export class UINavigation extends Component {
    static contextType = UIContainerContext;

    render() {
        let onSelect = event => {
            this.props.onSelect(event.currentTarget.id);
        };

        return (
            <div className={`ui-navigation ${this.props.className || ""} animate-in`}>
                <div
                    className="ui-navigation-back-button"
                    onClick={() => {
                        if (!this.context) {
                            this.props.onBack();
                        }
                    }}
                >
                    <img src={getStaticUrl("/images/backIcon.svg")} />
                </div>
                <div className={"ui-navigation-items " + (this.props.fullHeight ? "full-height" : "")}>
                    {React.Children && React.Children.map(this.props.children, child => {
                        if (child) {
                            return React.cloneElement(child, {
                                key: child.props.id,
                                selected: this.props.selected,
                                onSelect: onSelect
                            });
                        }
                    })}
                </div>
            </div>
        );
    }
}

export class UINavigationItemHeader extends Component {
    render() {
        return (
            <div className={"ui-navigation-item-header " + (this.props.fullHeight ? "full-height" : "")}>
                {this.props.title && (
                    <span className="title">{this.props.title}</span>
                )}
                {React.Children.map(this.props.children, child => {
                    if (child) {
                        return React.cloneElement(child, {
                            selected: this.props.selected,
                            onSelect: this.props.onSelect,
                        });
                    }
                })}
            </div>
        );
    }
}

export class UINavigationItem extends Component {
    render() {
        let selected = this.props.selected == this.props.id;

        return (
            <div
                id={this.props.id}
                className={`ui-navigation-item ${selected ? "selected" : ""}`}
                onClick={this.props.onSelect}
            >
                <div className={classNames("nav-label", this.props.proBadge ? "with-pro-badge" : null)}>
                    {this.props.icon && <div className="icon-container">
                        <Icon iconName={this.props.icon} />
                        {this.props.iconLabel && <span className="icon-label">{this.props.iconLabel}</span>}
                    </div>}
                    {this.props.image && this.props.image}
                    {this.props.title}
                </div>
                {this.props.proBadge || null}
                {React.Children.map(this.props.children, child => {
                    if (child) {
                        return React.cloneElement(child, {
                            selected: this.props.selected,
                            onSelect: this.props.onSelect
                        });
                    }
                })}
            </div>
        );
    }
}

export class UISubNavigationItem extends Component {
    render() {
        let selected = this.props.selected == this.props.id;

        return (
            <div
                id={this.props.id}
                className={`ui-sub-navigation-item ${selected ? "selected" : ""}`}
                onClick={this.props.onSelect}
            >
                {this.props.title}
            </div>
        );
    }
}

export class Section extends Component {
    render() {
        return (
            <Fragment>
                {this.props.title && <div className="section-title">{this.props.title}{this.props.proBadge || null}</div>}
                <section>{this.props.children}</section>
            </Fragment>
        );
    }
}

export class BlueButton extends Component {
    render() {
        return (
            <Button variant="contained" color="primary" {...this.props}>
                {this.props.children}
            </Button>
        );
    }
}

export class BlueOutlinedButton extends Component {
    render() {
        return (
            <Button variant="outlined" color="primary" {...this.props}>
                {this.props.children}
            </Button>
        );
    }
}

export class YellowButton extends Component {
    render() {
        return (
            <Button variant="contained" {...this.props} className="yellow">
                {this.props.children}
            </Button>
        );
    }
}

export class ScaryButton extends Component {
    render() {
        return (
            <Button variant="contained" {...this.props} className="orange">
                {this.props.children}
            </Button>
        );
    }
}

export class DarkButton extends Component {
    render() {
        return (
            <Button variant="contained" {...this.props} className="dark">
                {this.props.children}
            </Button>
        );
    }
}
